<template>
  <div>
    <h3>Online Training</h3>
    <vs-breadcrumb class="mt-2">
      <li><router-link to="/surveys">Surveys</router-link><span class="vs-breadcrum--separator">/</span></li>
      <li v-if="item" aria-current="page" class="active">Online Training - {{ $translate(item.title) }}</li>
    </vs-breadcrumb>
    <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none mt-8" id="profile-tabs" :key="isSmallerScreen">

      <!-- GENERAL -->
      <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'General' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <online-training-general v-if="item" :item="item" />
        </div>
      </vs-tab>

      <!-- MODULES -->
      <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Modules' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <online-training-modules v-if="item" :item="item" />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import OnlineTrainingGeneral from './OnlineTrainingGeneral.vue'
import OnlineTrainingModules from './OnlineTrainingModules.vue'

export default {
  components: {
    OnlineTrainingGeneral,
    OnlineTrainingModules
  },
  data () {
    return {
      surveyId: '',
      item: null
    }
  },
  methods: {
    getItem: function () {
      this.$vs.loading()

      const url = process.env.VUE_APP_API +'/Surveys/4/' + this.surveyId;
      
      this.$http.get(url)
          .then(resp => {
            console.log("Online Training:", resp.data);
            this.item = resp.data;
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => {
            this.$vs.loading.close()
          })
    },
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  },

  created() {
    this.surveyId = this.$route.params.surveyId;
    this.getItem();
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
